
import { computed, defineComponent, ref, onMounted } from "vue";
import ViewHeader from "@/components/ViewHeader.vue";
import BackAndCancelFooter from "@/components/BackAndCancelFooter.vue";
import DropdownInput from "@/components/Inputs/DropdownInput.vue";
import TotalRow from "@/components/TotalRow.vue";
import { useStore } from "@/store";
import { CashPayment } from "@/models/Order";
import { useRouter } from "vue-router";
import swal from "sweetalert2";
import { useI18n } from "vue-i18n";
import NumberInput from "@/components/Inputs/NumberInput.vue";
import { Validation } from "@/models/Validation";
import useVuelidate from "@vuelidate/core";
import { required, not, sameAs } from "@vuelidate/validators";
import { nextTick } from "q";


export default defineComponent({
  props: {
    paymentIndex: {
      type: Number,
    },
  },
  components: {
    ViewHeader,
    BackAndCancelFooter,
    DropdownInput,
    TotalRow,
    NumberInput,
  },
  async setup(props) {
    const store = useStore();
    const router = useRouter();
    const { t } = useI18n();
    const currencies = computed(() =>
      store.state.currencies.map((x) => {
        return { id: x.id, name: x.symbol };
      })
    );
    const orderTotal = computed(() => store.getters.orderTotal);
    const localCurrencyId = computed(() => store.state.localCurrencyId);
    const canEditRate = computed(() => store.getters.canEditRate);
    const p = new CashPayment();
    const payment =
      props.paymentIndex != undefined
        ? computed(
          () =>
            store.state.order.payment.cashPayments.find(
              (x) => x.index == props.paymentIndex
            ) ?? new CashPayment()
        )
        : ref(p);
    const orderPayment = computed(() => store.state.order.payment);
    if (props.paymentIndex == undefined) {
      payment.value.amount =
        store.getters.orderBalance > 0 ? store.getters.orderBalance : 1;
      payment.value.currencyId = 1;
      payment.value.localCurrencyRate =
        store.state.currencyRates.find(
          (x) => x.currencyId == payment.value.currencyId
        )?.rate ?? 1;
    }
    const total = computed(() => payment.value.amount * payment.value.localCurrencyRate);

    onMounted(() => {
      nextTick(() => focusNext([0]));
    });

    const submitForm = async (event) => {
      const valid = await v.value.$validate();
      if (!valid) {
        event.preventDefault();
        event.stopPropagation();
        swal.fire({
          icon: "info",
          text: t("alert.pleaseFillAllRequiredFields"),
        });
      } else {
        if (props.paymentIndex == undefined) {
          store.state.order.payment.addPayment(payment.value);
        }
        router.back();
      }
    };

    function focusNext(indexes: number[]) {
      for (const index of indexes) {
        const el = document.querySelector(`[data-index="${index + 1}"]`);
        if (el instanceof HTMLElement) {
          setTimeout(() => el.focus(), 100);
          return;
        }
      }
    }

    function changeCurrency(e) {
      payment.value.currencyId = e.value;
      payment.value.localCurrencyRate =
        store.state.currencyRates.find((x) => x.currencyId == e.value)?.rate ??
        1;

      nextTick(() => focusNext([2, 3]));
    }

    const rules = {
      amount: { required, not: not(sameAs(0)) },
      currencyId: { required },
      localCurrencyRate: { required },
    };

    const scope = "validationScope";
    const validation = new Validation(rules, scope);

    const v = useVuelidate({ $scope: scope });

    return {
      focusNext,
      currencies,
      total,
      payment,
      submitForm,
      changeCurrency,
      orderTotal,
      orderPayment,
      validation,
      v,
      canEditRate,
      localCurrencyId,
    };
  },
});
